import { coerceConfidence, formatConfidence } from '../chunk-CHBEZMSL.js';
import '../chunk-7WFU2LWK.js';
import { humanizeFieldName } from '../chunk-7NWIUGSG.js';
import { isCandidateContractReference, expandContractLinks, contractObservations, RelatedAddressLinkRowSchema, GraphEdgeSchema, RelationshipActivitySchema } from '../chunk-34IRTR4R.js';
export { ContractObservationSchema, ContractRelationshipOptionsSchema, contractObservations, contractPredicateLabel, expandContractLinks, hasContractReferenceDirection, isCandidateContractReference } from '../chunk-34IRTR4R.js';
import '../chunk-6XJKVJAV.js';
import '../chunk-XHKWG5FD.js';
import '../chunk-KLRGM47X.js';
import '../chunk-XR6TNFQL.js';
import { unwrapData } from '../chunk-HIWBYL4O.js';
import '../chunk-FK4BRGM4.js';
import '../chunk-X34AGPO3.js';
import '../chunk-L6V3D5WY.js';
import '../chunk-7B3IWQPL.js';
import '../chunk-5WIUKZF6.js';
import '../chunk-HCZGW64N.js';
import '../chunk-A7ABC66H.js';
import '../chunk-IAXDOK4V.js';
import '../chunk-BFUJOKOR.js';
import '../chunk-DQNP4KXT.js';
import '../chunk-WVLHT3DL.js';
import '../chunk-EE4CQDCZ.js';
import '../chunk-RAPPRZ3C.js';
import '../chunk-BJ3WKLB6.js';
import '../chunk-INX63VAT.js';
import { nodeId, parseNodeId, keys } from '../chunk-HV5UL5NN.js';
export { nodeId, parseNodeId, splitChainKey } from '../chunk-HV5UL5NN.js';
import '../chunk-6B5KO6TH.js';
import '../chunk-3QN2VZ56.js';
import { WALLET_HISTORY_CHAIN_IDS } from '../chunk-427X3MFA.js';
import { parseAddressReference } from '../chunk-EJL7TYGE.js';
import '../chunk-O2TUCS6S.js';
import { addressFamily, isValidAddress, normalizeAddress, str } from '../chunk-STJDIADC.js';
import { toCanonicalChainId, resolveChain, chainsEqual, chainDisplayName } from '../chunk-WUQGV726.js';
import '../chunk-GPJ572YS.js';
import '../chunk-N7SZ66QO.js';
import '../chunk-LD6PO66H.js';
import '../chunk-AHISJLEK.js';
import '../chunk-QXYP3KHC.js';
import '../chunk-O5TCTRWM.js';
import '../chunk-O3OIBNP7.js';
import '../chunk-PZ5AY32C.js';
import { z } from 'zod';

// src/related-addresses/vocab.generated.ts
var LINK_TIERS = [
  "flow",
  "veto",
  "structural",
  "identity",
  "behavioral",
  "correction"
];
var LINK_KINDS = [
  { kind: "tx_count", tier: "flow", label: "repeated transactions", description: "The pair exchanged at least the policy's minimum number of transactions.", nominal: 0.7, family: "flow", identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "bidirectional_flow", tier: "flow", label: "value both ways", description: "Value moved in both directions, each direction in a transaction of its own.", nominal: 0.85, family: "flow", identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "value_transfer", tier: "flow", label: "value threshold crossed", description: "Value in a configured asset crossed the policy's threshold.", nominal: 0.65, family: "flow", identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "dust_suppression", tier: "veto", label: "dust-sized transfers only", description: "Every transfer between the pair is dust or zero: the shape of an address-poisoning stream.", nominal: 0.9, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "atomic_swap", tier: "veto", label: "traded in a single transaction", description: "Value both ways only inside the same transactions: a purchase, not a relationship.", nominal: 0.9, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "unresolved_execution", tier: "veto", label: "execution unresolved", description: "The pair's support rests on transactions whose execution outcome could not be read.", nominal: 1, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "contract_deployer", tier: "structural", label: "contract deployer", description: "The address deployed the contract directly, or through a pure deployment proxy.", nominal: 0.97, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: true, roles: [["deployer", "deployer"], ["deployed_contract", "deployed_address"]], symmetric_role: null },
  { kind: "factory_creation", tier: "structural", label: "created through a factory", description: "The address had a recognised factory mint the contract; the factory is its deployer.", nominal: 0.9215, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: true, roles: [["factory_requester", "requested_by"], ["factory_created", "deployed_address"]], symmetric_role: null },
  { kind: "nested_calldata", tier: "structural", label: "named in calldata", description: "The address is named as a beneficiary inside calldata the other submitted, with a corroborating payment.", nominal: 0.75, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "first_funder", tier: "structural", label: "first funder", description: "The address made the first payment the wallet ever received, witnessed by its first activity.", nominal: 0.8, family: null, identity_capable: false, value_derived: true, hypothesis_method: false, provenance: false, roles: [["funder", "funder"], ["funded_wallet", "funded"]], symmetric_role: null },
  { kind: "sweep_counterparty", tier: "structural", label: "balance swept", description: "The address received substantially the whole running balance of the other in one transfer.", nominal: 0.7, family: null, identity_capable: false, value_derived: true, hypothesis_method: false, provenance: false, roles: [["swept_wallet", "swept_from"], ["consolidator", "swept_to"]], symmetric_role: null },
  { kind: "batch_fan_in", tier: "structural", label: "co-funded a target", description: "The address paid a common target alongside others inside a short window.", nominal: 0.65, family: null, identity_capable: false, value_derived: true, hypothesis_method: false, provenance: false, roles: [["batch_funder", "sender"], ["funding_target", "target"]], symmetric_role: null },
  { kind: "batch_fan_out", tier: "structural", label: "batched payout", description: "The address received one share of a payout the other split across several recipients.", nominal: 0.65, family: null, identity_capable: false, value_derived: true, hypothesis_method: false, provenance: false, roles: [["distributor", "source"], ["payout_wallet", "recipient"]], symmetric_role: null },
  { kind: "eip7702_co_authorization", tier: "structural", label: "co-authorised delegation", description: "Authorizations for both accounts were included in one EIP-7702 transaction; inclusion does not prove that either delegation was applied or that the accounts share an owner.", nominal: 0.99, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "ownership_transfer", tier: "structural", label: "ownership handed over", description: "A contract's owner or proxy admin role was handed from one address to the other.", nominal: 0.8, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "bridge_correlation", tier: "structural", label: "bridge legs matched", description: "Two legs of one bridge transfer, matched on the protocol's own message identifier.", nominal: 0.9, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: true, roles: null, symmetric_role: "bridge_party" },
  { kind: "utxo_co_spend", tier: "structural", label: "shared transaction inputs", description: "Outputs spent together as inputs of one transaction; PayJoin can defeat the heuristic.", nominal: 0.7, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "utxo_change_candidate", tier: "structural", label: "possible change output", description: "An output whose script type matches the inputs', a candidate change address.", nominal: 0.5, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "solana_mint_authority", tier: "structural", label: "mint authority", description: "The address was set as the mint authority when the token was initialised.", nominal: 1, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "cardano_shared_payment_credential", tier: "structural", label: "shared payment credential", description: "Two addresses encode the same payment credential; ownership of the key is unproven.", nominal: 1, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "cardano_shared_stake_credential", tier: "structural", label: "shared stake credential", description: "Two addresses encode the same stake credential; ownership of the key is unproven.", nominal: 1, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "contract_state_reference", tier: "structural", label: "contract reference", description: "A contract's state (owner, admin, getter) names the address at the recorded block.", nominal: 1, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: true, roles: null, symmetric_role: null },
  { kind: "same_address_cross_chain", tier: "identity", label: "same key on another chain", description: "One externally owned key active on several chains: one key, one actor.", nominal: 0.98, family: null, identity_capable: true, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: "cross_chain_self" },
  { kind: "solana_ata_owner", tier: "identity", label: "token account ownership", description: "An SPL token account and the wallet that owns it, verified at a finalized snapshot.", nominal: 0.99, family: null, identity_capable: true, value_derived: false, hypothesis_method: false, provenance: false, roles: [["token_account", "token_account"], ["token_account_owner", "owner"]], symmetric_role: null },
  { kind: "exchange_deposit_forwarding", tier: "behavioral", label: "exchange deposit forwarding", description: "An exact receipt forwarded to a known exchange within the forwarding window.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "shared_exchange_deposit", tier: "behavioral", label: "shared exchange deposit", description: "Several wallets forwarded into one exchange deposit address inside a window.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "airdrop_consolidation", tier: "behavioral", label: "airdrop consolidation", description: "Many exact airdrop receipts forwarded to one collector.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "coordinated_token_launch", tier: "behavioral", label: "coordinated token launch", description: "A token deployer funded fresh wallets that bought the token in the same operation.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "distributed_holder_coordination", tier: "behavioral", label: "coordinated holder distribution", description: "Common material allocations followed by reciprocal transfers; ownership remains unproven.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "possible_peel_chain", tier: "behavioral", label: "possible peel chain", description: "A dominant remainder forwarded hop by hop; a flow allocation, not proof of control.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "closed_value_cycle", tier: "behavioral", label: "closed value cycle", description: "Value that left an address came back along a unique chronological path.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: true, provenance: false, roles: null, symmetric_role: null },
  { kind: "likely_common_control", tier: "behavioral", label: "common-control hypothesis", description: "Two or more independent behavioural methods agree; reversible, ownership unproven.", nominal: 0.6, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null },
  { kind: "manual_link", tier: "correction", label: "pinned by a correction", description: "A person pinned the address to this identity; a claim, not evidence, with no strength.", nominal: 0, family: null, identity_capable: false, value_derived: false, hypothesis_method: false, provenance: false, roles: null, symmetric_role: null }
];
var LINK_KIND_LABELS = {
  "tx_count": "repeated transactions",
  "bidirectional_flow": "value both ways",
  "value_transfer": "value threshold crossed",
  "dust_suppression": "dust-sized transfers only",
  "atomic_swap": "traded in a single transaction",
  "unresolved_execution": "execution unresolved",
  "contract_deployer": "contract deployer",
  "factory_creation": "created through a factory",
  "nested_calldata": "named in calldata",
  "first_funder": "first funder",
  "sweep_counterparty": "balance swept",
  "batch_fan_in": "co-funded a target",
  "batch_fan_out": "batched payout",
  "eip7702_co_authorization": "co-authorised delegation",
  "ownership_transfer": "ownership handed over",
  "bridge_correlation": "bridge legs matched",
  "utxo_co_spend": "shared transaction inputs",
  "utxo_change_candidate": "possible change output",
  "solana_mint_authority": "mint authority",
  "cardano_shared_payment_credential": "shared payment credential",
  "cardano_shared_stake_credential": "shared stake credential",
  "contract_state_reference": "contract reference",
  "same_address_cross_chain": "same key on another chain",
  "solana_ata_owner": "token account ownership",
  "exchange_deposit_forwarding": "exchange deposit forwarding",
  "shared_exchange_deposit": "shared exchange deposit",
  "airdrop_consolidation": "airdrop consolidation",
  "coordinated_token_launch": "coordinated token launch",
  "distributed_holder_coordination": "coordinated holder distribution",
  "possible_peel_chain": "possible peel chain",
  "closed_value_cycle": "closed value cycle",
  "likely_common_control": "common-control hypothesis",
  "manual_link": "pinned by a correction"
};
var MANUAL_LINK_KIND = "manual_link";
var LINK_ROLE_LABELS = {
  "deployer": "deployed a contract",
  "deployed_contract": "is a contract this actor deployed",
  "factory_requester": "had a factory create another of these addresses",
  "factory_created": "was created by a factory at another of these addresses' request",
  "funder": "funded another of these addresses into existence",
  "funded_wallet": "was funded into existence by another of these addresses",
  "swept_wallet": "was emptied into another of these addresses",
  "consolidator": "received another address's whole balance",
  "batch_funder": "paid a common target alongside other addresses",
  "funding_target": "was funded by a batch of these addresses",
  "distributor": "paid out to a batch of these addresses",
  "payout_wallet": "received one share of a batched payout",
  "token_account": "is a token account of one of these wallets",
  "token_account_owner": "owns one of these token accounts",
  "cross_chain_self": "is the same key seen on another chain",
  "bridge_party": "is one leg of the same bridge transfer"
};
var REJECTION_REASONS = [
  "partner_ceiling",
  "suppressed",
  "bidirectionality",
  "below_link_floor",
  "no_endorsement",
  "disabled_signal",
  "hypothesis_disabled",
  "hypothesis_binding_mismatch",
  "hypothesis_support_mismatch",
  "hypothesis_unknown_method",
  "hypothesis_insufficient_methods",
  "hypothesis_expired",
  "hypothesis_retracted",
  "hypothesis_contested",
  "hypothesis_not_yet_valid",
  "hypothesis_candidate",
  "malformed_hypothesis",
  "malformed_evidence",
  "retracted_evidence",
  "unsettled_identity",
  "provisional_evidence",
  "revoked",
  "future_evidence",
  "expired",
  "stale_evidence",
  "unfinalized_identity",
  "reversible_evidence",
  "missing_proof",
  "proof_binding_mismatch",
  "proof_chain_mismatch",
  "malformed_proof",
  "not_identity",
  "disabled",
  "mutable_control"
];
var REJECTION_LABELS = {
  "partner_ceiling": "withheld: the address has too many flow partners to read as one actor's hub",
  "suppressed": "refused by a suppressor",
  "bidirectionality": "one-way flow only",
  "below_link_floor": "below the confidence floor",
  "no_endorsement": "no rule argued for the pair",
  "disabled_signal": "the rule is weighted to zero",
  "hypothesis_disabled": "hypotheses are disabled by policy",
  "hypothesis_binding_mismatch": "the hypothesis names different addresses",
  "hypothesis_support_mismatch": "the hypothesis' supporting transactions changed",
  "hypothesis_unknown_method": "the hypothesis cites an unknown method",
  "hypothesis_insufficient_methods": "too few independent methods agree",
  "hypothesis_expired": "the hypothesis expired",
  "hypothesis_retracted": "a supporting transaction was retracted",
  "hypothesis_contested": "counter-evidence contests the hypothesis",
  "hypothesis_not_yet_valid": "the hypothesis is not valid yet",
  "hypothesis_candidate": "a candidate hypothesis, not yet likely",
  "malformed_hypothesis": "the stored hypothesis could not be read",
  "malformed_evidence": "the stored evidence could not be read",
  "retracted_evidence": "the supporting transaction was retracted",
  "unsettled_identity": "an identity claim on an unsettled transaction",
  "provisional_evidence": "a preview of a transaction not yet mined",
  "revoked": "the claim was revoked",
  "future_evidence": "the evidence is dated in the future",
  "expired": "the claim expired",
  "stale_evidence": "older than the policy allows",
  "unfinalized_identity": "an identity claim without a finalized attestation",
  "reversible_evidence": "an identity claim on a reversible transaction",
  "missing_proof": "the row carries no proof",
  "proof_binding_mismatch": "the proof names different addresses",
  "proof_chain_mismatch": "the proof names different chains",
  "malformed_proof": "the proof could not be read",
  "not_identity": "the proof is a relationship, not an identity claim",
  "disabled": "clustering is disabled by policy",
  "mutable_control": "a control snapshot that can change; not permanent"
};
var CLUSTER_RUN_STATUSES = [
  "queued",
  "running",
  "succeeded",
  "partial",
  "failed"
];
var CLUSTER_RUN_TRIGGERS = [
  "adhoc",
  "pipeline",
  "exploration",
  "scheduled",
  "backfill"
];
var CLUSTER_MEMBER_ROLES = [
  "seed",
  "member"
];
var CLUSTER_ANALYSIS_PROFILES = [
  "standard",
  "deep"
];
var CLUSTER_OVERRIDE_ACTIONS = [
  "exclude",
  "pin",
  "detach",
  "track"
];
var CLUSTER_OVERRIDE_ACTION_SPECS = {
  "exclude": { label: "Never cluster", description: "This address must never be clustered with anything; it loses every identity edge.", needs_peer: false, identity_effect: "isolate", snapshot_effect: "remove", queues_analysis: false },
  "pin": { label: "Pin to identity", description: "This address is the same actor as the peer, whatever the evidence found.", needs_peer: true, identity_effect: "join", snapshot_effect: "add", queues_analysis: false },
  "detach": { label: "Remove from identity", description: "This address is not part of the peer's identity; it stays eligible for every other one.", needs_peer: true, identity_effect: "cut", snapshot_effect: "remove_if_peer_inside", queues_analysis: false },
  "track": { label: "Track related address", description: "Show this address beside the peer as a related address, without claiming they are one actor.", needs_peer: true, identity_effect: null, snapshot_effect: "add", queues_analysis: false }
};
var CLUSTER_OVERRIDE_SCOPES = [
  "user",
  "team",
  "tenant",
  "org",
  "customer",
  "system"
];
var EXCLUSION_SOURCES = [
  "configured",
  "minted_venue",
  "defi_venue",
  "eip7702_delegate",
  "bridge_entry",
  "precompile",
  "protocol",
  "bridge",
  "exchange",
  "shared_infrastructure",
  "account_abstraction",
  "token",
  "deployment_proxy",
  "null_address",
  "multicall3",
  "catalog",
  "dex_pool_role"
];
var EXCLUSION_SOURCE_LABELS = {
  "configured": "an address this run was asked to hold out",
  "minted_venue": "a liquidity venue this run watched a factory create \u2014 pools, vaults and per-token exchanges belong to whoever trades in them, which is to say nobody",
  "defi_venue": "a DeFi venue this run watched being used \u2014 a pool trading or taking liquidity, a vault or lending market taking deposits \u2014 by the logs its protocol declares",
  "eip7702_delegate": "a wallet implementation many unrelated accounts delegate to",
  "bridge_entry": "an entry point wallets call to reach a bridge \u2014 it takes each user's funds and deposits them into the bridge in the same transaction",
  "precompile": "a chain precompile",
  "protocol": "a contract belonging to a known protocol",
  "bridge": "bridge infrastructure",
  "exchange": "an exchange-controlled address",
  "shared_infrastructure": "listed shared infrastructure",
  "account_abstraction": "account-abstraction infrastructure",
  "token": "a token contract",
  "deployment_proxy": "a public deployment proxy",
  "null_address": "the zero address every mint comes from and every burn goes to",
  "multicall3": "the Multicall3 singleton",
  "catalog": "an address the catalog classifies as infrastructure",
  "dex_pool_role": "an AMM pool, by the entity membership recorded for it"
};
var COVERAGE_NOTE_KINDS = [
  "budget",
  "scope",
  "provider"
];
var CLUSTER_READ_LIMITS = {
  "default_page_limit": 50,
  "max_page_limit": 200,
  "max_identity_accounts": 100,
  "max_lookup_accounts": 50
};
var CLUSTER_SUMMARY_FIELDS = [
  "chain_ids",
  "cluster_id",
  "confidence",
  "confidence_tier",
  "created_at",
  "link_count",
  "member_count",
  "rationale",
  "retracted_by_run",
  "run_id",
  "seed_node_id",
  "superseded_by",
  "updated_at"
];
var ACTOR_SUMMARY_FIELDS = [
  "actor_id",
  "chain_ids",
  "confidence",
  "confidence_tier",
  "created_at",
  "founding_node_id",
  "link_count",
  "member_count",
  "merged_into",
  "run_id",
  "updated_at"
];
var RUN_SUMMARY_FIELDS = [
  "address_count",
  "chain_ids",
  "cluster_count",
  "created_at",
  "finished_at",
  "run_id",
  "seed_actor_id",
  "seed_chain_id",
  "seed_cluster_id",
  "seed_excluded_by",
  "seed_node_id",
  "started_at",
  "status",
  "trigger",
  "truncated"
];

// src/related-addresses/model.ts
var TERMINAL_CLUSTER_RUN_STATUSES = /* @__PURE__ */ new Set(["succeeded", "partial", "failed"]);
function isClusterRunStatus(value) {
  return typeof value === "string" && CLUSTER_RUN_STATUSES.includes(value);
}
function isTerminalClusterRunStatus(status) {
  return TERMINAL_CLUSTER_RUN_STATUSES.has(status);
}
function clusterRunAnswered(status) {
  return status === "succeeded" || status === "partial";
}
function clusterRunReplacesAnswer(status) {
  return status === "succeeded";
}
var CLUSTER_RUN_STATUS_LABELS = {
  queued: "Queued",
  running: "Analysing",
  succeeded: "Done",
  partial: "Done (partial)",
  failed: "Failed"
};
function isCoverageNoteKind(value) {
  return typeof value === "string" && COVERAGE_NOTE_KINDS.includes(value);
}
function isLiveActor(actor) {
  return Boolean(actor) && !actor?.merged_into;
}
var LOOKUP_CHUNK_ACCOUNTS = Math.min(10, CLUSTER_READ_LIMITS.max_lookup_accounts);
var LOOKUP_CHUNK_CONCURRENCY = 3;
var CLUSTER_ANALYSIS_PROFILE_LABELS = {
  standard: "Standard analysis",
  deep: "Deep analysis"
};
function isClusterAnalysisProfile(value) {
  return typeof value === "string" && CLUSTER_ANALYSIS_PROFILES.includes(value);
}
function clusterAnalysisProfileLabel(profile) {
  return isClusterAnalysisProfile(profile) ? CLUSTER_ANALYSIS_PROFILE_LABELS[profile] : null;
}
function viewCorrections(view) {
  if (!view) return [];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const correction of [
    ...view.identity?.corrections ?? [],
    ...view.snapshot?.corrections ?? [],
    ...view.snapshot?.tracking ?? []
  ]) {
    if (!correction?.override_sk || seen.has(correction.override_sk)) continue;
    seen.add(correction.override_sk);
    out.push(correction);
  }
  return out;
}
function mergeRoleCompositions(compositions) {
  const present = compositions.filter((c) => Boolean(c));
  if (present.length === 0) return null;
  if (present.length === 1) return present[0];
  const byRole = /* @__PURE__ */ new Map();
  for (const composition of present) {
    for (const group of composition.roles) {
      const existing = byRole.get(group.role) ?? { label: group.label, holders: /* @__PURE__ */ new Map() };
      for (const holder of group.holders) {
        const seen = existing.holders.get(holder.node_id);
        existing.holders.set(
          holder.node_id,
          seen ? {
            ...seen,
            // The strongest claim, not an average: a member with one weak
            // link and one strong one is described by the strong one.
            confidence: Math.max(seen.confidence, holder.confidence),
            is_seed: seen.is_seed || holder.is_seed,
            evidence: [...seen.evidence, ...holder.evidence]
          } : holder
        );
      }
      byRole.set(group.role, existing);
    }
  }
  const members = /* @__PURE__ */ new Set();
  const unroled = /* @__PURE__ */ new Set();
  for (const composition of present) {
    for (const node of composition.unroled) unroled.add(node);
    for (const group of composition.roles) {
      for (const holder of group.holders) members.add(holder.node_id);
    }
  }
  for (const node of members) unroled.delete(node);
  const roles = [...byRole.entries()].map(([role, entry]) => {
    const holders = [...entry.holders.values()].sort((a, b) => b.confidence - a.confidence);
    return { role, label: entry.label, holder_count: holders.length, holders };
  }).sort((a, b) => b.holder_count - a.holder_count || a.role.localeCompare(b.role));
  const first = present[0];
  return {
    // No single cluster owns this, and inventing an id would let a caller cache
    // it as though one did.
    cluster_id: "",
    subject_kind: "merged",
    seed_node_id: first.seed_node_id,
    as_of: Math.max(...present.map((c) => c.as_of)),
    window: first.window,
    member_count: members.size + unroled.size,
    members_read: present.reduce((total, c) => total + c.members_read, 0),
    links_read: present.reduce((total, c) => total + c.links_read, 0),
    truncated: present.some((c) => c.truncated),
    roles,
    unroled: [...unroled]
  };
}
var ADDRESS_CLUSTER_STATE_LABELS = {
  clustered: "Clustered",
  // The reader's own correction, not a finding of the analysis.
  "excluded-by-correction": "Held out by a correction",
  "held-out-by-correction": "Removed from its identity by a correction",
  analysing: "Analysing",
  "stands-alone": "Stands alone",
  "shared-infrastructure": "Shared infrastructure",
  "never-analysed": "Never analysed"
};
function addressClusterState(lookup) {
  if (!lookup) return "never-analysed";
  if (lookup.clustered && (lookup.actor || lookup.cluster)) return "clustered";
  if (lookup.view.identity.excluded) return "excluded-by-correction";
  if (lookup.view.held_out) return "held-out-by-correction";
  if (lookup.last_run?.seed_excluded_by) return "shared-infrastructure";
  if (lookup.last_run?.status === "queued" || lookup.last_run?.status === "running") return "analysing";
  return lookup.last_run ? "stands-alone" : "never-analysed";
}
function isIdentityClaim(link) {
  if (link.kind === "contract_state_reference" || link.kind === "likely_common_control") return false;
  if (link.rejection_reason || link.same_actor === false) return false;
  return link.identity_claim === true;
}
function isAdmittedLink(link) {
  if (link.kind === "contract_state_reference") return false;
  return !link.rejection_reason && Boolean(link.cluster_id);
}
function splitLinksByClaim(links) {
  const sameActor = [];
  const related = [];
  const rejected = [];
  for (const link of links ?? []) {
    (link.rejection_reason ? rejected : isIdentityClaim(link) ? sameActor : related).push(link);
  }
  return { sameActor, related, rejected };
}
function linkCounterpart(link, nodeId2) {
  return link.a_id === nodeId2 ? link.b_id : link.a_id;
}
var CLUSTER_OVERRIDE_AUTHORING_SCOPES = CLUSTER_OVERRIDE_SCOPES.filter((scope) => scope !== "system");
var CLUSTER_OVERRIDE_SCOPE_LABELS = {
  system: "Everyone",
  customer: "My customer",
  org: "My org",
  tenant: "My tenant",
  team: "My team",
  user: "Only me"
};
var CLUSTER_PEER_OVERRIDE_ACTIONS = new Set(
  CLUSTER_OVERRIDE_ACTIONS.filter((action) => CLUSTER_OVERRIDE_ACTION_SPECS[action].needs_peer)
);
function overrideNeedsPeer(action) {
  return CLUSTER_OVERRIDE_ACTION_SPECS[action].needs_peer;
}
var CLUSTER_OVERRIDE_ACTION_LABELS = Object.fromEntries(
  CLUSTER_OVERRIDE_ACTIONS.map((action) => [action, CLUSTER_OVERRIDE_ACTION_SPECS[action].label])
);
var CLUSTER_OVERRIDE_SCOPE_RANK = Object.fromEntries(
  CLUSTER_OVERRIDE_SCOPES.map((scope, index) => [scope, CLUSTER_OVERRIDE_SCOPES.length - index])
);

// src/related-addresses/api.ts
function encodePathSegment(value) {
  return encodeURIComponent(value).replace(
    /[!'()*]/g,
    (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`
  );
}
function verdictScalars(res) {
  return {
    node_id: res.node_id ?? "",
    clustered: Boolean(res.clustered && (res.actor || res.cluster)),
    clusters_truncated: res.clusters_truncated === true,
    superseded_clusters: nodeIds(res.superseded_clusters),
    private_network: res.private_network ?? null,
    profile: profileOf(res.profile),
    analysis: analysisOf(res.analysis),
    view: normalizeView(res.view)
  };
}
function normalizeLookup(res) {
  return {
    ...verdictScalars(res),
    actor: res.actor ?? null,
    cluster: res.cluster ?? null,
    last_run: res.last_run ?? null,
    newer_run: res.newer_run ?? null,
    active_run: res.active_run ?? null,
    answer_run: res.answer_run ?? null,
    other_clusters: Array.isArray(res.other_clusters) ? res.other_clusters : [],
    members: Array.isArray(res.members) ? res.members : [],
    actor_members: Array.isArray(res.actor_members) ? res.actor_members : [],
    roles: normalizeRoles(res.roles),
    coverage: res.coverage ?? null
  };
}
function normalizeSummary(res) {
  return {
    ...verdictScalars(res),
    actor: res.actor ?? null,
    cluster: res.cluster ?? null,
    last_run: res.last_run ?? null,
    newer_run: res.newer_run ?? null,
    active_run: res.active_run ?? null,
    answer_run: res.answer_run ?? null,
    other_clusters: Array.isArray(res.other_clusters) ? res.other_clusters : []
  };
}
function profileOf(value) {
  if (isClusterAnalysisProfile(value)) return value;
  throw new Error("The service answered with an analysis profile this build does not know.");
}
function analysisOf(value) {
  if (value === "shared" || value === "private") return value;
  throw new Error("The service did not say whether the answer is the shared or a private analysis.");
}
function nodeIds(value) {
  return Array.isArray(value) ? value.filter((id) => typeof id === "string") : [];
}
function corrections(value) {
  return (value ?? []).filter((row) => Boolean(row) && typeof row.override_sk === "string").map((row) => ({ ...row, peer_node_id: row.peer_node_id ?? null }));
}
function normalizeView(raw) {
  if (!raw || typeof raw !== "object") {
    throw new Error("The service did not say how the reader's corrections shaped the answer.");
  }
  const identity = raw.identity ?? {};
  const snapshot = raw.snapshot && typeof raw.snapshot === "object" ? raw.snapshot : null;
  return {
    corrected: Boolean(raw.corrected),
    held_out: raw.held_out === true,
    identity: {
      corrected: Boolean(identity.corrected),
      // Defaults TRUE: `exact: false` qualifies an answer, and a misshaped
      // reply must not invent a qualification nobody sent.
      exact: identity.exact !== false,
      excluded: identity.excluded === true,
      removed: nodeIds(identity.removed),
      added: nodeIds(identity.added),
      corrections: corrections(identity.corrections),
      corrections_truncated: nodeIds(identity.corrections_truncated)
    },
    snapshot: snapshot ? {
      corrected: Boolean(snapshot.corrected),
      removed: nodeIds(snapshot.removed),
      added: nodeIds(snapshot.added),
      corrections: corrections(snapshot.corrections),
      tracking: corrections(snapshot.tracking)
    } : null
  };
}
function runOf(run) {
  if (!run || typeof run.run_id !== "string" || !run.run_id) {
    throw new Error("The service did not return a valid run status. Refresh to check whether it started.");
  }
  return run;
}
function clampLimit(limit) {
  if (typeof limit !== "number" || !Number.isFinite(limit)) return CLUSTER_READ_LIMITS.default_page_limit;
  return Math.min(Math.max(Math.trunc(limit), 1), CLUSTER_READ_LIMITS.max_page_limit);
}
function rolesQuery(query) {
  if (!query?.include_roles) {
    return query?.include_coverage ? { include_coverage: true } : {};
  }
  const q = { include_roles: true };
  if (query.include_coverage) q.include_coverage = true;
  if (typeof query.since === "number") q.since = Math.trunc(query.since);
  if (typeof query.until === "number") q.until = Math.trunc(query.until);
  return q;
}
function normalizeRoles(roles) {
  if (!roles || typeof roles !== "object") return null;
  const raw = roles;
  return {
    cluster_id: raw.cluster_id ?? "",
    subject_kind: raw.subject_kind ?? "cluster",
    seed_node_id: raw.seed_node_id ?? "",
    as_of: raw.as_of ?? 0,
    window: raw.window ?? { since: null, until: null, basis: "observed" },
    member_count: raw.member_count ?? 0,
    members_read: raw.members_read ?? 0,
    links_read: raw.links_read ?? 0,
    // Defaults TRUE when the reply is misshaped, for the same reason `complete`
    // defaults false below: presenting part of an actor as the whole of it is
    // the one failure this panel must not have.
    truncated: raw.truncated ?? true,
    roles: Array.isArray(raw.roles) ? raw.roles : [],
    unroled: Array.isArray(raw.unroled) ? raw.unroled : []
  };
}
function createRelatedAddressesApi(client, options = {}) {
  const base = (options.basePath ?? "/related-addresses").replace(/\/+$/, "");
  const clusters = `${base}/clusters`;
  const runs = `${base}/cluster-runs`;
  const overrides = `${base}/cluster-overrides`;
  const lookup = (chain, address, tail) => `${base}/addresses/${encodeURIComponent(chain)}/${encodeURIComponent(address)}/${tail}`;
  const api = {
    async getCluster(clusterId, query, signal) {
      const q = {
        limit: clampLimit(query?.limit),
        ...rolesQuery(query)
      };
      if (query?.cursor) q.cursor = query.cursor;
      if (query?.links_cursor) q.links_cursor = query.links_cursor;
      const res = unwrapData(
        await client.get(`${clusters}/${encodeURIComponent(clusterId)}`, {
          query: q,
          signal,
          cacheTtlMs: 0
        })
      );
      if (!res?.cluster) return null;
      return {
        cluster: res.cluster,
        actor: res.actor ?? null,
        members: Array.isArray(res.members) ? res.members : [],
        links: Array.isArray(res.links) ? res.links : [],
        next_cursor: res.next_cursor ?? null,
        // The links page's own cursor and completeness, as the service states
        // them. `links_complete` defaults FALSE: a caller must get the
        // service's word that the page is the whole listing, never a guess
        // from a count — and a reply that does not say is not complete.
        links_next_cursor: res.links_next_cursor ?? null,
        links_complete: res.links_complete === true,
        roles: normalizeRoles(res.roles),
        coverage: res.coverage ?? null,
        private_network: res.private_network ?? null,
        profile: profileOf(res.profile),
        analysis: analysisOf(res.analysis),
        view: normalizeView(res.view)
      };
    },
    async identitiesFor(accounts, signal) {
      const wanted = [...new Set(accounts.filter(Boolean))];
      const out = [];
      const per = CLUSTER_READ_LIMITS.max_identity_accounts;
      for (let start = 0; start < wanted.length; start += per) {
        const res = unwrapData(
          await client.get(`${base}/identities`, {
            query: { accounts: wanted.slice(start, start + per).join(",") },
            signal
          })
        );
        if (!res || !Array.isArray(res.items)) {
          throw new Error("The service did not return a valid identities lookup.");
        }
        for (const item of res.items) {
          if (!item || typeof item.account !== "string" || typeof item.node_id !== "string") continue;
          out.push({
            account: item.account,
            node_id: item.node_id,
            actor: item.actor ?? null,
            corrected: item.corrected === true,
            held_out: item.held_out === true
          });
        }
      }
      return out;
    },
    async clusterLookupsFor(accounts, signal) {
      const wanted = [...new Set(accounts.filter(Boolean))];
      const chunks = [];
      for (let start = 0; start < wanted.length; start += LOOKUP_CHUNK_ACCOUNTS) {
        chunks.push(wanted.slice(start, start + LOOKUP_CHUNK_ACCOUNTS));
      }
      const readChunk = async (chunk) => {
        const out = [];
        const res = unwrapData(
          await client.get(`${base}/address-clusters`, {
            query: { accounts: chunk.join(",") },
            signal,
            cacheTtlMs: 0
          })
        );
        if (!res || !Array.isArray(res.items) || res.items.length !== chunk.length) {
          throw new Error("The service did not return a valid address-clusters lookup.");
        }
        res.items.forEach((item, i) => {
          const requested = chunk[i];
          const account = typeof item?.account === "string" ? item.account : requested;
          if (!item || Boolean(item.error) || typeof item.node_id !== "string") {
            out.push({ account, requested, error: "lookup_failed" });
            return;
          }
          out.push({ ...normalizeSummary(item), account, requested });
        });
        return out;
      };
      const results = new Array(chunks.length);
      let next = 0;
      const worker = async () => {
        while (next < chunks.length) {
          const at = next++;
          try {
            results[at] = await readChunk(chunks[at]);
          } catch (err) {
            if (signal?.aborted) throw err;
            results[at] = { failed: err };
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(LOOKUP_CHUNK_CONCURRENCY, chunks.length) }, worker));
      const failed = results.filter((r) => !Array.isArray(r));
      if (failed.length > 0 && failed.length === chunks.length) throw failed[0].failed;
      return results.flatMap(
        (r, i) => Array.isArray(r) ? r : chunks[i].map((requested) => ({
          account: requested,
          requested,
          error: "lookup_failed"
        }))
      );
    },
    async clusterForAddress(chain, address, query, signal) {
      const q = { ...rolesQuery(query) };
      if (query?.include_members) q.include_members = true;
      if (typeof query?.limit === "number") q.limit = clampLimit(query.limit);
      const res = unwrapData(
        await client.get(lookup(chain, address, "cluster"), {
          query: q,
          signal,
          cacheTtlMs: 0
        })
      );
      if (!res || typeof res.node_id !== "string" || !res.node_id || typeof res.clustered !== "boolean") {
        throw new Error("The service did not return a valid address-cluster lookup.");
      }
      return normalizeLookup(res);
    },
    async linksForAddress(chain, address, query, signal) {
      const q = { limit: clampLimit(query?.limit) };
      if (query?.kind) q.kind = query.kind;
      if (query?.deterministic_only) q.deterministic_only = true;
      const res = unwrapData(
        await client.get(lookup(chain, address, "links"), {
          query: q,
          signal,
          cacheTtlMs: 0
        })
      );
      const items = Array.isArray(res?.items) ? res.items : [];
      return {
        items,
        next_cursor: res?.next_cursor ?? null,
        node_id: res?.node_id ?? "",
        // Defaults FALSE: claiming a partial list is complete would present a
        // truncated evidence trail as the whole of it.
        complete: res?.complete ?? false,
        profile: profileOf(res?.profile),
        analysis: analysisOf(res?.analysis)
      };
    },
    async requestRun(input) {
      const body = { address: input.address };
      if (input.chain_id) body.chain_id = input.chain_id;
      if (input.chain_ids?.length) body.chain_ids = input.chain_ids;
      if (typeof input.max_hops === "number") body.max_hops = input.max_hops;
      if (input.force) body.force = true;
      if (input.resume_run_id) body.resume_run_id = input.resume_run_id;
      if (input.contract_relationships) body.contract_relationships = input.contract_relationships;
      const res = unwrapData(await client.post(clusters, body));
      return {
        run: runOf(res?.run),
        reused: Boolean(res?.reused),
        // Defaults TRUE when the reply is misshaped: a caller that thinks nothing
        // was queued stops polling and never sees the answer it paid for.
        queued: res?.queued ?? true,
        // Only ever true when the service said so: resuming a checkpoint is a
        // different promise from starting a fresh walk.
        resuming: res?.resuming === true,
        lane: res?.lane ?? null,
        profile: profileOf(res?.profile)
      };
    },
    async listOverrides(signal) {
      const res = unwrapData(
        await client.get(overrides, {
          signal,
          // Never cached: this list is the audit surface for a control that
          // changes results, and a stale one hides a correction somebody just
          // made — or shows one they just withdrew.
          cacheTtlMs: 0
        })
      );
      return {
        overrides: Array.isArray(res?.overrides) ? res.overrides : [],
        count: res?.count ?? res?.overrides?.length ?? 0,
        allowed_scopes: Array.isArray(res?.allowed_scopes) ? res.allowed_scopes : []
      };
    },
    async putOverride(input) {
      const body = {
        action: input.action,
        chain_id: input.chain_id,
        address: input.address,
        reason: input.reason
      };
      if (overrideNeedsPeer(input.action) && input.peer_address) {
        body.peer_address = input.peer_address;
        if (input.peer_chain_id) body.peer_chain_id = input.peer_chain_id;
      }
      if (input.scope) body.scope = input.scope;
      if (input.scope === "team" && input.team_id) body.team_id = input.team_id;
      if (input.replaces) body.replaces = input.replaces;
      if (input.expected_updated_at !== void 0) body.expected_updated_at = input.expected_updated_at;
      if (typeof input.enabled === "boolean") body.enabled = input.enabled;
      const res = unwrapData(await client.post(overrides, body));
      if (!res?.override) {
        throw new Error("The service did not return the saved correction.");
      }
      return {
        override: res.override,
        created: res.created ?? true,
        replaced: res.replaced ?? null,
        analysis_queued: typeof res.analysis_queued === "string" ? res.analysis_queued : null
      };
    },
    async deleteOverride(overrideSk, expectedUpdatedAt) {
      const res = unwrapData(
        await client.delete(
          `${overrides}/${encodePathSegment(overrideSk)}`,
          { query: { expected_updated_at: expectedUpdatedAt } }
        )
      );
      return Boolean(res?.deleted);
    },
    async listRuns(query, signal) {
      if (!query?.address || !query?.chain) {
        throw new Error("Runs are listed per address: pass both address and chain.");
      }
      const q = {
        address: query.address,
        chain: query.chain,
        limit: clampLimit(query.limit)
      };
      if (query.status) q.status = query.status;
      const page = unwrapData(await client.get(runs, { query: q, signal, cacheTtlMs: 0 }));
      return {
        items: Array.isArray(page?.items) ? page.items : [],
        next_cursor: page?.next_cursor ?? null,
        profile: profileOf(page?.profile)
      };
    },
    async getRun(runId, signal) {
      const res = unwrapData(
        await client.get(`${runs}/${encodeURIComponent(runId)}`, {
          signal,
          // Never cached: this is the poll target, and a cached status is a UI
          // that waits forever on a run that finished.
          cacheTtlMs: 0
        })
      );
      return {
        run: runOf(res?.run),
        cluster: res?.cluster ?? null,
        profile: profileOf(res?.profile)
      };
    },
    pollRun(runId, signal) {
      return api.getRun(runId, signal);
    }
  };
  return api;
}

// src/related-addresses/members.ts
function memberTie(member) {
  if (member.actor_member === true) return "same-actor";
  if (member.actor_member === false) return "related";
  return "unknown";
}
function memberRowId(row) {
  return row.nodeId || nodeId(row.chainId, row.address);
}
function isManualMember(row) {
  return row.linkKinds.includes(MANUAL_LINK_KIND);
}
function words(id) {
  return humanizeFieldName(id).toLowerCase().trim();
}
function isLinkKind(kind) {
  return Object.hasOwn(LINK_KIND_LABELS, kind);
}
function linkKindLabel(kind) {
  if (isLinkKind(kind)) return LINK_KIND_LABELS[kind];
  return words(kind) || "link";
}
function isRejectionReason(reason) {
  return REJECTION_REASONS.includes(reason);
}
var REJECTION_SENTENCES = {
  partner_ceiling: "One of these addresses moves value both ways with too many others to group them as one actor; the pair is shown, not merged.",
  suppressed: "A suppression rule rejected this claim.",
  bidirectionality: "The required activity in both directions was not observed.",
  below_link_floor: "The evidence did not meet the confidence threshold.",
  no_endorsement: "No ownership rule endorsed this pair.",
  disabled_signal: "This signal was disabled by the analysis policy.",
  hypothesis_disabled: "Behavioural hypotheses are switched off by the analysis policy, so this one was not admitted.",
  hypothesis_binding_mismatch: "The stored hypothesis names different addresses from the pair it is filed under.",
  hypothesis_support_mismatch: "The transactions the hypothesis rests on changed since it was formed.",
  hypothesis_unknown_method: "The hypothesis cites a method this analysis does not know.",
  hypothesis_insufficient_methods: "Too few independent methods agree for a common-control hypothesis.",
  hypothesis_expired: "The hypothesis expired before this read.",
  hypothesis_retracted: "A transaction the hypothesis rested on was retracted.",
  hypothesis_contested: "Counter-evidence contests the hypothesis.",
  hypothesis_not_yet_valid: "The hypothesis is dated after this read and is not valid yet.",
  hypothesis_candidate: "A candidate hypothesis: not yet likely, so it establishes nothing.",
  malformed_hypothesis: "The stored hypothesis could not be read.",
  malformed_evidence: "The stored evidence could not be read.",
  retracted_evidence: "This transaction was dropped, replaced, expired, or removed by a reorg.",
  unsettled_identity: "An identity claim cannot rest on a transaction that has not settled.",
  provisional_evidence: "Pending or predicted activity: no ownership conclusion. The mined result may differ or never occur.",
  revoked: "The ownership attestation was revoked.",
  future_evidence: "The evidence was dated after the analysis time.",
  expired: "The ownership attestation expired.",
  stale_evidence: "The evidence was too old under this policy.",
  unfinalized_identity: "The ownership attestation was not finalized.",
  reversible_evidence: "This ownership claim is waiting for stronger finality.",
  missing_proof: "The stored row carries no proof to re-check.",
  proof_binding_mismatch: "The stored proof names different addresses from the row it is filed under.",
  proof_chain_mismatch: "The stored proof names different chains from the row it is filed under.",
  malformed_proof: "The stored proof could not be read.",
  not_identity: "The proof describes a relationship, not an identity claim.",
  disabled: "Clustering is disabled by the analysis policy.",
  mutable_control: "A control snapshot that can change is not a permanent identity claim."
};
function rejectionReason(reason) {
  if (reason && isRejectionReason(reason)) {
    return { short: REJECTION_LABELS[reason], long: REJECTION_SENTENCES[reason] };
  }
  const text = words(reason ?? "") || "refused";
  return { short: text, long: text };
}
function evidenceLabel(link) {
  if (link.kind === "manual_link" && link.seed_evidence?.tracking_override_sk) return "analyst continuation \xB7 unverified";
  if (link.kind === "contract_state_reference" && link.description) return link.description;
  const kind = (link.kind ?? "").trim();
  let known = kind && kind !== "unknown" ? linkKindLabel(kind) : "";
  if (kind === "likely_common_control") {
    const labels = {
      likely: "likely",
      candidate: "candidate",
      contested: "contested",
      expired: "expired",
      retracted: "retracted",
      not_yet_valid: "not yet valid",
      invalid: "invalid"
    };
    const status = typeof link.hypothesis_status === "string" && Object.hasOwn(labels, link.hypothesis_status) ? labels[link.hypothesis_status] : "unvalidated";
    known = `${known} \xB7 ${status}`;
  }
  if (!link.rejection_reason) return known || linkKindLabel(kind);
  const why = rejectionReason(link.rejection_reason).short;
  return known ? `${known} \xB7 ${why}` : why;
}
function toMemberRows(members, links, actorMembers = []) {
  const byNode = /* @__PURE__ */ new Map();
  const add = (nodeId2, link) => {
    if (!nodeId2) return;
    const list = byNode.get(nodeId2);
    if (list) list.push(link);
    else byNode.set(nodeId2, [link]);
  };
  for (const link of (links ?? []).filter(isAdmittedLink)) {
    add(link.a_id, link);
    add(link.b_id, link);
  }
  const whyFor = (nodeId2) => [...byNode.get(nodeId2) ?? []].sort(
    (a, b) => (b.confidence ?? 0) - (a.confidence ?? 0)
  );
  const actorByNode = new Map(actorMembers.map((member) => [member.node_id, member]));
  const rows = members.map((member) => ({
    nodeId: member.node_id,
    address: member.address,
    chainId: member.chain_id,
    role: member.role,
    confidence: member.confidence ?? 0,
    linkKinds: [.../* @__PURE__ */ new Set([...member.link_kinds ?? [], ...actorByNode.get(member.node_id)?.join_kinds ?? []])],
    why: whyFor(member.node_id),
    tie: memberTie(member)
  }));
  const seen = new Set(rows.map((row) => row.nodeId));
  for (const member of actorMembers) {
    if (!member.node_id || seen.has(member.node_id)) continue;
    seen.add(member.node_id);
    rows.push({
      nodeId: member.node_id,
      address: member.address,
      chainId: member.chain_id,
      role: "member",
      confidence: member.confidence ?? 0,
      linkKinds: [...member.join_kinds ?? []],
      why: whyFor(member.node_id),
      tie: "same-actor"
    });
  }
  return rows;
}

// src/related-addresses/holdOut.ts
function isExclusionSource(value) {
  return typeof value === "string" && EXCLUSION_SOURCES.includes(value);
}
function heldOutReason(source) {
  return isExclusionSource(source) ? EXCLUSION_SOURCE_LABELS[source] : "shared infrastructure";
}

// src/related-addresses/runs.ts
function coverageNotes(run, kind) {
  const notes = run.coverage ?? [];
  return kind ? notes.filter((note) => note.kind === kind) : [...notes];
}
function walkCutShort(run) {
  return coverageNotes(run, "budget").length > 0 || run.truncated === true;
}
function uncoveredScope(run) {
  return coverageNotes(run, "scope");
}
function statsOf(run) {
  return run.source_stats ?? {};
}
function providerTrouble(run) {
  const entry = statsOf(run).provider_errors;
  const notes = coverageNotes(run, "provider");
  const count = entry?.count ?? 0;
  if (count > 0) {
    const distinct = entry?.distinct ?? notes.map((note) => note.note);
    return { count, distinct };
  }
  if (notes.length > 0) return { count: notes.length, distinct: notes.map((note) => note.note) };
  return null;
}
function readNothing(run) {
  return (run.address_count ?? 0) === 0;
}
function addressesRead(run) {
  let total = 0;
  for (const block of Object.values(statsOf(run).reads ?? {})) total += block?.addresses ?? 0;
  return total;
}
function failuresHidTheAnswer(run, trouble) {
  return trouble.count >= addressesRead(run);
}
function historyUnsupported(trouble) {
  return Boolean(trouble?.distinct.some((reason) => reason.startsWith("WalletGatewayUnsupported:")));
}
function providerFailureText(failure) {
  return (failure ?? "").replace(/\s*:\s*$/, "").trim();
}
function runProblemText(problem) {
  const text = problem.replace(/^[A-Z][A-Za-z0-9]*(?:Error|Exception|Timeout)\s*:\s*/, "");
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : problem;
}
function runInFlight(run) {
  return run?.status === "queued" || run?.status === "running";
}
function runVerdict(input) {
  const { lookup, session } = input;
  const settled = !input.isLoading && !input.error;
  const newerRun = lookup?.newer_run ?? null;
  const reportedRun = session.run ?? newerRun ?? lookup?.last_run ?? null;
  const bannerRun = newerRun && settled && !(session.runError && session.run?.run_id === newerRun.run_id) ? newerRun : null;
  const answered = lookup?.answer_run ?? null;
  const unfinishedAnswer = !bannerRun && settled && answered && isTerminalClusterRunStatus(answered.status) && !clusterRunReplacesAnswer(answered.status) ? answered : null;
  const answerRun = (session.run && (clusterRunReplacesAnswer(session.run.status) || session.run.run_id === lookup?.last_run?.run_id) ? session.run : null) ?? lookup?.last_run ?? session.run ?? null;
  const resumableRun = reportedRun?.status === "partial" && reportedRun.resume_available ? reportedRun : null;
  const others = lookup?.other_clusters ?? [];
  const grownHere = others.some((row) => row.seed_node_id === input.nodeId);
  return {
    reportedRun,
    bannerRun,
    unfinishedAnswer,
    answerRun,
    resumableRun,
    grownHere,
    seededElsewhere: others.length > 0 && !grownHere
  };
}

// src/related-addresses/subject.ts
function chainRef(chain) {
  return toCanonicalChainId(chain);
}
function chainChoices(address, availableChains) {
  const family = addressFamily(address);
  const fits = (chainId) => (!family || (resolveChain(chainId)?.family ?? null) === family) && isValidAddress(address, chainId);
  const known = availableChains.filter((c) => c && fits(c));
  const unknown = WALLET_HISTORY_CHAIN_IDS.filter(
    (c) => fits(c) && !known.some((k) => chainRef(k) === chainRef(c))
  );
  return {
    known,
    rest: unknown.filter((c) => !resolveChain(c)?.isTestnet),
    testnets: unknown.filter((c) => resolveChain(c)?.isTestnet)
  };
}
function onlyChainFor(address, availableChains) {
  const valid = availableChains.filter((candidate) => isValidAddress(address, candidate));
  return valid.length === 1 ? valid[0] : null;
}

// src/related-addresses/activity.ts
function relationshipActivity(link) {
  const activity = link.activity;
  if (!activity) return void 0;
  return { ...activity, observations: activity.observations ?? [], forwarding: activity.forwarding ?? [] };
}
var DEFAULT_ACTIVITY_FILTER = Object.freeze({ includeUnknown: false });
function activityFilterActive(filter = {}) {
  return filter.from != null || filter.to != null || filter.hourFrom != null || filter.hourTo != null || !!filter.forwardingOnly;
}
function activityFilterError(filter) {
  if ([filter.from, filter.to].some((n) => n != null && (!Number.isFinite(n) || n <= 0))) return "Enter a valid UTC date range.";
  if (filter.from != null && filter.to != null && filter.from > filter.to) return "Start must be before end.";
  if ([filter.hourFrom, filter.hourTo].some((n) => n != null && (!Number.isInteger(n) || n < 0 || n > 23))) return "Hours must be between 00 and 23 UTC.";
  if (filter.hourFrom != null && filter.hourFrom === filter.hourTo) return "Choose different start and end hours, or Any for the full day.";
  return void 0;
}
function activityTimeMatches(timestamp, filter) {
  if (!Number.isFinite(timestamp) || timestamp <= 0 || activityFilterError(filter)) return false;
  if (filter.from != null && timestamp < filter.from) return false;
  if (filter.to != null && timestamp > filter.to) return false;
  const hour = Math.floor(timestamp / 3600) % 24;
  const start = filter.hourFrom ?? 0, end = filter.hourTo ?? 24;
  return start <= end ? hour >= start && hour < end : hour >= start || hour < end;
}
function matchingForwarding(link, filter = {}) {
  return (relationshipActivity(link)?.forwarding ?? []).filter((p) => activityTimeMatches(p.received_at, filter) && activityTimeMatches(p.sent_at, filter));
}
function activityMatches(link, filter = {}) {
  if (!activityFilterActive(filter)) return true;
  if (activityFilterError(filter)) return false;
  if (filter.forwardingOnly) return matchingForwarding(link, filter).length > 0;
  const activity = relationshipActivity(link);
  if (activity?.observations.some((point) => activityTimeMatches(point.timestamp, filter))) return true;
  return !!filter.includeUnknown && activityTimingIncomplete(link);
}
function activityTimingIncomplete(link) {
  const activity = relationshipActivity(link);
  return !activity || activity.undated_count > 0 || !!activity.truncated || !!activity.history_partial || activity.dated_count === 0 || activity.observations.length === 0;
}
function activityFilterLabel(filter) {
  if (!activityFilterActive(filter)) return "All observed times";
  const parts = [];
  const date = (n) => new Date(n * 1e3).toISOString().slice(0, 10);
  if (filter.from != null || filter.to != null) parts.push(`${filter.from ? date(filter.from) : "Any start"} \u2192 ${filter.to ? date(filter.to) : "Any end"}`);
  if (filter.hourFrom != null || filter.hourTo != null) parts.push(`${String(filter.hourFrom ?? 0).padStart(2, "0")}:00\u2013${String(filter.hourTo ?? 24).padStart(2, "0")}:00 UTC`);
  if (filter.forwardingOnly) parts.push("Possible forwarding");
  if (filter.includeUnknown && !filter.forwardingOnly) parts.push("Including unknown timing");
  return parts.join(" \xB7 ");
}
function activitySummary(links, filter = {}) {
  const timestamps = /* @__PURE__ */ new Map();
  const forwards = /* @__PURE__ */ new Set();
  let unknownLinks = 0, truncatedLinks = 0;
  for (const link of links) {
    const activity = relationshipActivity(link);
    if (activityTimingIncomplete(link)) unknownLinks++;
    if (activity?.truncated) truncatedLinks++;
    for (const p of activity?.observations ?? []) if (activityTimeMatches(p.timestamp, filter)) timestamps.set(p.tx_id, p.timestamp);
    for (const p of matchingForwarding(link, filter)) forwards.add(JSON.stringify([p.via_id, p.asset_id, p.incoming_tx_id, p.outgoing_tx_id]));
  }
  const hours = Array(24).fill(0);
  for (const timestamp of timestamps.values()) {
    const hour = Math.floor(timestamp / 3600) % 24;
    hours[hour] = (hours[hour] ?? 0) + 1;
  }
  const dates = [...timestamps.values()].sort((a, b) => a - b);
  return { count: timestamps.size, hours, first: dates[0], last: dates.at(-1), unknownLinks, truncatedLinks, forwardingCount: forwards.size };
}
function activityDate(timestamp) {
  return timestamp ? new Date(timestamp * 1e3).toISOString().replace("T", " ").slice(0, 19) + " UTC" : "Unknown";
}
function activityRangeLabel(activity) {
  if (!activity?.dated_count) return "Timing unknown";
  return `${activityDate(activity.first_seen)} \u2014 ${activityDate(activity.last_seen)}`;
}

// src/related-addresses/presentation.ts
var RELATED_ADDRESS_GRAPH_LIMITS = { nodes: 12, edges: 24 };
var RELATIONSHIP_CLAIM_LABELS = {
  manual: "Manual hand-off",
  identity: "Verified on-chain control",
  related: "Observed relationships",
  coordination: "Suspected coordination",
  candidate: "Unverified candidate",
  rejected: "Rejected claim",
  provisional: "Pending / predicted"
};
var RELATIONSHIP_CLAIM_DESCRIPTIONS = {
  manual: "An analyst's instruction to continue from another wallet, possibly across an exchange or chain. It does not prove a withdrawal, transfer or common ownership.",
  identity: "The service validated on-chain control evidence. This does not identify a person or establish beneficial ownership.",
  related: "Observed activity or references connect these addresses without establishing common control.",
  coordination: "Behavior suggests coordination. Hypotheses can expire or be contested; strength is not an ownership probability.",
  candidate: "An unverified lead or analyst assertion. It does not establish an observed relationship or control.",
  rejected: "This claim was refused or invalidated. Other evidence for the same pair may still exist.",
  provisional: "Pending or predicted activity may expire, be replaced or change when mined. It does not establish control."
};
function relationshipClaim(link) {
  if (isProvisionalRelationship(link)) return "provisional";
  if (link.rejection_reason) return "rejected";
  if (link.kind === "manual_link" && link.seed_evidence?.tracking_override_sk) return "manual";
  const spec = LINK_KINDS.find((item) => item.kind === link.kind);
  if (spec?.tier === "behavioral") {
    if (["expired", "retracted", "contested", "not_yet_valid", "invalid"].includes(link.hypothesis_status ?? "")) return "rejected";
    return "coordination";
  }
  if (spec?.identity_capable && isIdentityClaim(link)) return "identity";
  if (spec?.identity_capable || spec?.tier === "correction" || isCandidateContractReference(link)) return "candidate";
  return "related";
}
function isCurrentRelationshipClaim(claim) {
  return claim === "identity" || claim === "related" || claim === "coordination" || claim === "manual";
}
function pairKey(source, target) {
  return source < target ? `${source}\0${target}` : `${target}\0${source}`;
}
function relationshipRowId(sortKey, occurrence) {
  return `rel-${keys.contentHash(sortKey)}-${occurrence}`;
}
function buildRelatedAddressView(input) {
  const nodes = /* @__PURE__ */ new Map();
  const seedId = nodeId(input.chainId, input.address);
  const add = (chainId, address) => {
    const id = nodeId(chainId, address);
    const existing = nodes.get(id);
    if (existing) return existing;
    const node = {
      id,
      address: normalizeAddress(address, chainId),
      chainId: toCanonicalChainId(chainId) ?? chainId,
      isSeed: id === seedId,
      membership: "unconfirmed"
    };
    nodes.set(id, node);
    return node;
  };
  add(input.chainId, input.address);
  for (const member of input.members ?? []) {
    const node = add(member.chainId, member.address);
    node.membership = member.tie === "same-actor" ? "same-actor" : "snapshot";
    node.manual = isManualMember(member);
  }
  const asOf = input.asOf ?? Date.now() / 1e3;
  const currentLinks = input.links.map((link) => expirePreview(link, asOf));
  const relationships = [];
  const occurrences = /* @__PURE__ */ new Map();
  for (const link of expandContractLinks(currentLinks)) {
    const claim = relationshipClaim(link);
    const source = add(link.a_chain_id, link.a_address).id;
    const target = add(link.b_chain_id, link.b_address).id;
    const observationIds = contractObservations(link).map((fact) => fact.observation_id);
    const sortKey = JSON.stringify([source, target, link.kind, claim, link.tx_hash ?? "", observationIds, link.description ?? "", link.rejection_reason ?? ""]);
    const occurrence = occurrences.get(sortKey) ?? 0;
    occurrences.set(sortKey, occurrence + 1);
    relationships.push({
      id: relationshipRowId(sortKey, occurrence),
      sortKey,
      source,
      target,
      claim,
      link,
      // Filled below: it depends on rows that may not exist yet.
      pairAlsoAccepted: false
    });
  }
  const acceptedPairs = new Set(
    relationships.filter((row) => row.claim === "identity" || row.claim === "related").map((row) => pairKey(row.source, row.target))
  );
  for (const row of relationships) {
    if (row.claim === "rejected" && acceptedPairs.has(pairKey(row.source, row.target))) {
      row.pairAlsoAccepted = true;
    }
  }
  relationships.sort((a, b) => (b.link.confidence ?? 0) - (a.link.confidence ?? 0) || a.sortKey.localeCompare(b.sortKey));
  return { seedId, nodes: [...nodes.values()], relationships, movementEvidence: input.movementEvidence };
}
function filterRelatedAddressView(view, filter, query, minimumConfidence = 0, evidenceType = "all", activityFilter = {}) {
  const threshold = Number.isFinite(minimumConfidence) ? Math.max(0, Math.min(1, minimumConfidence)) : 0;
  const needle = query.trim().toLowerCase();
  const matchesNode = (node) => `${node.address} ${node.chainId} ${chainDisplayName(node.chainId)}`.toLowerCase().includes(needle);
  const matchingNodes = new Set(view.nodes.filter(matchesNode).map((node) => node.id));
  const relationships = view.relationships.filter((row) => {
    if (!activityMatches(row.link, activityFilter)) return false;
    if (evidenceType.startsWith("contract") && row.link.kind !== "contract_state_reference") return false;
    if (evidenceType === "contract-observed" && !contractObservations(row.link).some((fact) => fact.assurance === "observed")) return false;
    if (evidenceType === "other" && row.link.kind === "contract_state_reference") return false;
    if (threshold > 0 && (coerceConfidence(row.link.confidence) ?? -1) < threshold) return false;
    if (filter !== "all" && (filter === "accepted" ? !isCurrentRelationshipClaim(row.claim) : row.claim !== filter)) return false;
    return !needle || matchingNodes.has(row.source) || matchingNodes.has(row.target) || `${RELATIONSHIP_CLAIM_LABELS[row.claim]} ${evidenceLabel(row.link)} ${row.link.description ?? ""} ${row.link.tx_hash ?? ""} ${row.link.rejection_reason ?? ""}`.toLowerCase().includes(needle);
  });
  const visible = new Set(relationships.flatMap((row) => [row.source, row.target]));
  if (relationships.length > 0) visible.add(view.seedId);
  if (filter === "accepted" && threshold === 0 && evidenceType === "all" && !activityFilterError(activityFilter)) {
    const linked = new Set(view.relationships.flatMap((row) => [row.source, row.target]));
    for (const node of view.nodes) {
      const timing = !activityFilterActive(activityFilter) || activityFilter.includeUnknown && !activityFilter.forwardingOnly && !linked.has(node.id);
      if (timing && (node.isSeed || node.membership !== "unconfirmed") && (!needle || matchesNode(node))) visible.add(node.id);
    }
  }
  return { ...view, relationships, nodes: view.nodes.filter((node) => visible.has(node.id)) };
}
function isProvisionalRelationship(link) {
  return link.rejection_reason === "provisional_evidence";
}
function relationshipLifecycle(link) {
  const proof = link.seed_evidence;
  const state = proof?.finality || void 0;
  if (!state) return void 0;
  return { state, expiresAt: typeof proof?.valid_until === "number" ? proof.valid_until : void 0 };
}
function expireRelatedAddressPreviews(view, asOf) {
  return { ...view, relationships: view.relationships.map((row) => {
    const link = expirePreview(row.link, asOf);
    return row.claim === "provisional" && link !== row.link ? { ...row, claim: "rejected", link } : row;
  }) };
}
var EXPIRED = "expired";
function expirePreview(link, asOf) {
  const expiry = relationshipLifecycle(link)?.expiresAt;
  return isProvisionalRelationship(link) && expiry !== void 0 && expiry <= asOf ? { ...link, rejection_reason: EXPIRED, same_actor: false } : link;
}

// src/related-addresses/strength.ts
var STRENGTH_LABEL = "Strength";
var STRENGTH_EXPLAINER = "An evidence strength, not a probability. It ranks how firmly the recorded evidence ties addresses together and is not calibrated against outcomes: 70% does not mean a 70% chance.";
function formatStrength(score) {
  const pct = formatConfidence(score);
  return pct ? `strength ${pct}` : "";
}
function weakestLinkOf(row) {
  const raw = row?.weakest_link;
  if (!raw || typeof raw !== "object") return null;
  const link = raw;
  const aId = typeof link.a_id === "string" ? link.a_id : "";
  const bId = typeof link.b_id === "string" ? link.b_id : "";
  const confidence = typeof link.confidence === "number" ? link.confidence : NaN;
  if (!aId || !bId || !Number.isFinite(confidence)) return null;
  return { aId, bId, kind: typeof link.kind === "string" ? link.kind : "", confidence };
}
function strOrNull(value) {
  return typeof value === "string" ? str(value) ?? null : null;
}
function num(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}
function provenanceOf(run, actor) {
  const r = run ?? {};
  const a = actor ?? {};
  const runPolicy = strOrNull(r.policy_fingerprint);
  const actorPolicy = strOrNull(a.policy_fingerprint);
  const out = {
    runId: strOrNull(r.run_id) ?? strOrNull(a.run_id),
    policy: runPolicy ?? actorPolicy,
    engine: strOrNull(r.engine_version) ?? strOrNull(a.engine_version),
    finishedAt: num(r.finished_at) ?? num(a.updated_at),
    requestedBy: strOrNull(r.requested_by),
    identityOnOlderPolicy: Boolean(runPolicy && actorPolicy && runPolicy !== actorPolicy)
  };
  return out.runId || out.policy ? out : null;
}
function shortFingerprint(fingerprint) {
  return fingerprint ? fingerprint.slice(0, 8) : "";
}
function strengthViewOptions(cutoffs) {
  return [
    { view: "any", min: 0, label: "any strength" },
    { view: "medium", min: cutoffs.medium, label: `medium strength or above (\u2265 ${formatConfidence(cutoffs.medium)})` },
    { view: "high", min: cutoffs.high, label: `high strength only (\u2265 ${formatConfidence(cutoffs.high)})` }
  ];
}
function strengthViewMin(view, cutoffs) {
  return strengthViewOptions(cutoffs).find((option) => option.view === view)?.min ?? 0;
}
function filterByStrength(rows, min) {
  if (!(min > 0)) return { shown: [...rows], hidden: 0 };
  const shown = rows.filter((row) => (row.confidence ?? 0) >= min);
  return { shown, hidden: rows.length - shown.length };
}
function clusteringAttributionReason(input) {
  const parts = ["Selected from address clustering"];
  if (input.actorId) parts.push(`identity ${input.actorId}`);
  if (input.provenance?.runId) parts.push(`run ${input.provenance.runId}`);
  if (input.provenance?.policy) parts.push(`policy ${shortFingerprint(input.provenance.policy)}`);
  if (input.provenance?.engine) parts.push(`engine ${input.provenance.engine}`);
  const finite = input.strengths.filter((s) => Number.isFinite(s));
  if (finite.length > 0) {
    const lo = Math.min(...finite);
    const hi = Math.max(...finite);
    parts.push(
      lo === hi ? `strength ${formatConfidence(lo)}` : `strength ${formatConfidence(lo)}\u2013${formatConfidence(hi)}`
    );
  }
  return `${parts.join(" \xB7 ")}.`;
}

// src/related-addresses/caseReferences.ts
function accountParts(account) {
  const parsed = parseAddressReference(account);
  if (!parsed.chain) return null;
  const chainId = toCanonicalChainId(parsed.chain) ?? parsed.chain;
  const address = parsed.address;
  return chainId.includes(":") && address ? { chainId, address } : null;
}
function caseAddressSeed(account) {
  const parsed = accountParts(account);
  if (!parsed || parsed.chainId.endsWith(":*") || !isValidAddress(parsed.address, parsed.chainId)) return void 0;
  const address = normalizeAddress(parsed.address, parsed.chainId);
  return { ...parsed, address, id: nodeId(parsed.chainId, address) };
}
function addressWatchMatches(watch, address, chain) {
  if (watch.kind !== "address" || !watch.account) return false;
  const account = accountParts(watch.account);
  const chainId = toCanonicalChainId(chain) ?? chain;
  if (!account || account.chainId.split(":")[0] !== chainId.split(":")[0]) return false;
  if (normalizeAddress(account.address, chainId) !== normalizeAddress(address, chainId)) return false;
  return !watch.chains?.length || watch.chains.some((scope) => {
    const canonical = toCanonicalChainId(scope) ?? scope;
    return canonical === chainId || canonical === `${chainId.split(":")[0]}:*`;
  });
}
function caseAddressSeeds(watches) {
  const seeds = /* @__PURE__ */ new Map();
  for (const watch of watches) {
    if (watch.kind !== "address" || !watch.account) continue;
    const account = accountParts(watch.account);
    if (!account) continue;
    const scopes = watch.chains?.length ? watch.chains : [account.chainId];
    for (const scope of scopes) {
      const canonical = toCanonicalChainId(scope) ?? scope;
      const chainId = canonical.endsWith(":*") ? account.chainId : canonical;
      if (chainId.endsWith(":*") || !addressWatchMatches(watch, account.address, chainId) || !isValidAddress(account.address, chainId)) continue;
      const address = normalizeAddress(account.address, chainId);
      const id = nodeId(chainId, address);
      seeds.set(id, { id, address, chainId });
    }
  }
  return [...seeds.values()];
}
var ProofSchema = z.object({ metadata: z.object({
  verification: z.literal("pinned_receipt_event"),
  chain_id: z.string(),
  tx_hash: z.string().regex(/^0x[0-9a-fA-F]{64}$/),
  block_number: z.number().int().nonnegative(),
  block_hash: z.string().regex(/^0x[0-9a-fA-F]{64}$/),
  message_id: z.string(),
  role: z.enum(["source", "destination"]),
  receipt_status: z.literal("success"),
  definition_hash: z.string(),
  logs: z.array(z.object({ address: z.string(), log_index: z.union([z.string(), z.number()]).nullish(), event: z.string().optional() })).min(1)
}) });
function bridgeReceiptEvidence(link) {
  if (link.kind !== "bridge_correlation") return [];
  const values = link.values;
  return ["source", "destination"].flatMap((role) => {
    const rows = values?.[`${role}_evidence`];
    if (!Array.isArray(rows)) return [];
    return rows.flatMap((row) => {
      const parsed = ProofSchema.safeParse(row);
      if (!parsed.success || parsed.data.metadata.role !== role || parsed.data.metadata.message_id !== values?.id_value) return [];
      return [parsed.data.metadata];
    });
  });
}

// src/related-addresses/execution.ts
function movementProofs(link) {
  const unique = /* @__PURE__ */ new Map();
  for (const edge of link.flow_edges ?? []) {
    for (const proof of edge.movement_evidence ?? []) {
      if (proof?.observation?.id && proof?.binding?.state) unique.set(proof.observation.id, proof);
    }
  }
  return [...unique.values()];
}
function isMovementLink(link) {
  return link.kind === "observed_movement" || link.kind === "economic_attribution";
}
function executionPerspective(view, perspective) {
  if (perspective === "relationships") {
    const relationships = view.relationships.filter((row) => !isMovementLink(row.link));
    const ids = new Set(relationships.flatMap((row) => [row.source, row.target]));
    return { ...view, relationships, nodes: view.nodes.filter((n) => n.isSeed || n.membership !== "unconfirmed" || ids.has(n.id)) };
  }
  if (perspective === "ownership") {
    const relationships = view.relationships.filter((row) => row.claim === "identity");
    const ids = new Set(relationships.flatMap((row) => [row.source, row.target]));
    return { ...view, relationships, nodes: view.nodes.filter((n) => n.isSeed || ids.has(n.id)) };
  }
  const links = /* @__PURE__ */ new Map();
  const sources = [
    ...view.relationships.map((row) => ({ link: row.link, proofs: movementProofs(row.link) })),
    { link: RelatedAddressLinkRowSchema.parse({}), proofs: view.movementEvidence ?? [] }
  ];
  for (const source of sources) {
    for (const proof of source.proofs) {
      const fact = proof.observation;
      const economic = perspective === "economic";
      if (economic && (proof.attribution?.state !== "resolved" || !proof.attribution.actor)) continue;
      const sender = economic ? proof.attribution.actor : fact.from_address;
      if (!sender || !fact.to_address || !fact.chain_id) continue;
      links.set(fact.id, {
        ...source.link,
        id: fact.id,
        a_id: `${fact.chain_id}#${sender}`,
        b_id: `${fact.chain_id}#${fact.to_address}`,
        a_address: sender,
        b_address: fact.to_address,
        a_chain_id: fact.chain_id,
        b_chain_id: fact.chain_id,
        kind: economic ? "economic_attribution" : "observed_movement",
        same_actor: false,
        deterministic: true,
        rejection_reason: null,
        cluster_id: null,
        // A movement is receipt evidence, never an identity claim.
        identity_claim: false,
        corrected: false,
        hypothesis_status: null,
        confidence_tier: null,
        confidence: 1,
        tx_count: 1,
        tx_hash: fact.tx_id,
        description: `${economic ? "Attributed" : "Observed"} movement of ${economic ? proof.attribution?.output?.amount_raw ?? fact.amount_raw : fact.amount_raw} raw units. This is not ownership evidence.`,
        values: { movement_id: fact.id },
        seed_evidence: {},
        activity: RelationshipActivitySchema.parse(fact.timestamp && fact.tx_id ? {
          first_seen: fact.timestamp,
          last_seen: fact.timestamp,
          dated_count: 1,
          observations: [{ tx_id: `${fact.chain_id}:${fact.tx_id}`, timestamp: fact.timestamp }]
        } : { undated_count: 1 }),
        evidence: [],
        explanation: [],
        flow_edges: [GraphEdgeSchema.parse({
          from_id: `${fact.chain_id}#${sender}`,
          to_id: `${fact.chain_id}#${fact.to_address}`,
          from_chain: fact.chain_id,
          to_chain: fact.chain_id,
          movement_evidence: [proof]
        })]
      });
    }
  }
  const seed = view.nodes.find((n) => n.id === view.seedId);
  if (!seed) return { ...view, relationships: [] };
  return buildRelatedAddressView({ address: seed.address, chainId: seed.chainId, links: [...links.values()] });
}

// src/related-addresses/readEvidence.ts
var EVIDENCE_LINK_PAGE_CAP = 10;
async function readClusterLinks(api, clusterId, signal) {
  const links = [];
  let cursor = null;
  for (let page = 0; page < EVIDENCE_LINK_PAGE_CAP; page += 1) {
    const detail = await api.getCluster(
      clusterId,
      { limit: CLUSTER_READ_LIMITS.max_page_limit, ...cursor ? { links_cursor: cursor } : {} },
      signal
    );
    if (!detail) throw new Error("The cluster evidence was not returned.");
    links.push(...detail.links);
    if (detail.links_complete) return { links, complete: true };
    if (!detail.links_next_cursor) return { links, complete: false };
    cursor = detail.links_next_cursor;
  }
  return { links, complete: false };
}
async function readAddressClusterEvidence(api, chain, address, clusterId, signal) {
  const [page, cluster] = await Promise.all([
    api.linksForAddress(chain, address, { limit: CLUSTER_READ_LIMITS.max_page_limit }, signal),
    clusterId ? readClusterLinks(api, clusterId, signal) : Promise.resolve(null)
  ]);
  const links = /* @__PURE__ */ new Map();
  for (const link of [...cluster?.links ?? [], ...page.items]) {
    links.set(link.id || `${link.a_id}|${link.b_id}|${link.kind}`, link);
  }
  return { links: [...links.values()], complete: page.complete === true && !page.next_cursor && (cluster?.complete ?? true) };
}

// src/related-addresses/tracking.ts
var TRACKING_VIEW_LIMITS = { branches: 4 };
function trackingBranches(lookup, seedId, limit = TRACKING_VIEW_LIMITS.branches) {
  const active = (lookup?.view?.snapshot?.tracking ?? []).filter((row) => row.action === "track" && row.peer_node_id && row.node_id !== row.peer_node_id);
  const roots = /* @__PURE__ */ new Set([seedId, ...(lookup?.members ?? []).filter((row) => !row.link_kinds?.includes("manual_link")).map((row) => row.node_id)]);
  const adjacent = /* @__PURE__ */ new Map();
  for (const row of active) {
    for (const [from, to] of [[row.node_id, row.peer_node_id], [row.peer_node_id, row.node_id]]) {
      const peers = adjacent.get(from) ?? /* @__PURE__ */ new Set();
      peers.add(to);
      adjacent.set(from, peers);
    }
  }
  const distances = new Map([...roots].map((node) => [node, 0]));
  const queue = [...roots];
  for (let i = 0; i < queue.length; i++) {
    const source = queue[i];
    for (const target of adjacent.get(source) ?? []) {
      if (distances.has(target)) continue;
      distances.set(target, distances.get(source) + 1);
      queue.push(target);
    }
  }
  const corrections2 = active.filter((row) => distances.has(row.node_id) && distances.has(row.peer_node_id));
  const order = (a, b) => distances.get(a) - distances.get(b) || a.localeCompare(b);
  const all = [...adjacent.keys()].filter((node) => node !== seedId && distances.has(node)).sort(order).flatMap((node) => {
    const parsed = parseNodeId(node);
    return parsed.chain && parsed.address ? [{
      nodeId: node,
      chainId: parsed.chain,
      address: parsed.address,
      corrections: corrections2.filter((row) => {
        const target = row.node_id === seedId ? row.peer_node_id : row.peer_node_id === seedId ? row.node_id : order(row.node_id, row.peer_node_id) >= 0 ? row.node_id : row.peer_node_id;
        return target === node;
      })
    }] : [];
  });
  const cap = Number.isFinite(limit) ? Math.max(0, Math.floor(limit)) : TRACKING_VIEW_LIMITS.branches;
  return { branches: all.slice(0, cap), omitted: Math.max(0, all.length - cap), corrections: corrections2 };
}
function trackingRun(lookup) {
  return lookup?.active_run ?? lookup?.newer_run ?? lookup?.last_run ?? lookup?.answer_run ?? null;
}
function extendTrackedView(base, answers, corrections2 = answers.flatMap((answer) => answer.branch.corrections)) {
  const nodes = new Map(base.nodes.map((node) => [node.id, node]));
  const relationships = new Map(base.relationships.map((row) => [row.id, row]));
  const seen = /* @__PURE__ */ new Set();
  const manual = [];
  for (const correction of corrections2) {
    if (seen.has(correction.override_sk)) continue;
    seen.add(correction.override_sk);
    const from = parseNodeId(correction.peer_node_id);
    const to = parseNodeId(correction.node_id);
    manual.push({ ...RelatedAddressLinkRowSchema.parse({
      id: `tracking:${correction.override_sk}`,
      a_id: correction.peer_node_id,
      b_id: correction.node_id,
      a_chain_id: from.chain,
      a_address: from.address,
      b_chain_id: to.chain,
      b_address: to.address,
      kind: "manual_link",
      confidence: 0,
      same_actor: false,
      deterministic: false,
      tx_count: 0,
      description: correction.reason,
      seed_evidence: { tracking_override_sk: correction.override_sk, scope: correction.scope, updated_at: correction.updated_at, updated_by: correction.updated_by }
    }), identity_claim: false, corrected: true, hypothesis_status: null, confidence_tier: null });
  }
  const seed = parseNodeId(base.seedId);
  if (manual.length && seed.chain && seed.address) {
    const manualView = buildRelatedAddressView({ address: seed.address, chainId: seed.chain, links: manual });
    for (const node of manualView.nodes) {
      if (!nodes.has(node.id)) nodes.set(node.id, { ...node, membership: "unconfirmed", manual: true });
    }
    for (const row of manualView.relationships) relationships.set(row.id, row);
  }
  for (const answer of answers) {
    const branchView = buildRelatedAddressView({
      address: answer.branch.address,
      chainId: answer.branch.chainId,
      members: toMemberRows(answer.lookup?.members ?? [], answer.links ?? [], answer.lookup?.actor_members ?? []),
      links: answer.links ?? []
    });
    for (const node of branchView.nodes) {
      if (!nodes.has(node.id)) nodes.set(node.id, { ...node, isSeed: false, membership: "unconfirmed", manual: node.id === answer.branch.nodeId });
    }
    for (const row of branchView.relationships) if (!relationships.has(row.id)) relationships.set(row.id, row);
  }
  return { ...base, nodes: [...nodes.values()], relationships: [...relationships.values()] };
}

// src/related-addresses/funding.ts
var SOURCE_ROLES = {
  contract_deployer: { source: "deployer", target: "deployed_address", label: "Trace deployer funding" },
  first_funder: { source: "funder", target: "funded", label: "Trace this funder's sources" }
};
function fundingSources(links, chain, address) {
  const out = [];
  for (const link of links) {
    if (relationshipClaim(link) !== "related" || !(link.kind in SOURCE_ROLES)) continue;
    const role = SOURCE_ROLES[link.kind];
    const evidence = link.values;
    const target = evidence?.[role.target], source = evidence?.[role.source];
    if (typeof target !== "string" || typeof source !== "string" || !source || normalizeAddress(target, chain) !== normalizeAddress(address, chain)) continue;
    const endpoints = [[link.a_chain_id, link.a_address], [link.b_chain_id, link.b_address]];
    if (![target, source].every((value) => endpoints.some(([cid, addr]) => chainsEqual(cid, chain) && normalizeAddress(addr, chain) === normalizeAddress(value, chain)))) continue;
    out.push({ address: source, chain, label: role.label, link });
  }
  return out;
}

export { ACTOR_SUMMARY_FIELDS, ADDRESS_CLUSTER_STATE_LABELS, CLUSTER_ANALYSIS_PROFILES, CLUSTER_ANALYSIS_PROFILE_LABELS, CLUSTER_MEMBER_ROLES, CLUSTER_OVERRIDE_ACTIONS, CLUSTER_OVERRIDE_ACTION_LABELS, CLUSTER_OVERRIDE_ACTION_SPECS, CLUSTER_OVERRIDE_AUTHORING_SCOPES, CLUSTER_OVERRIDE_SCOPES, CLUSTER_OVERRIDE_SCOPE_LABELS, CLUSTER_OVERRIDE_SCOPE_RANK, CLUSTER_PEER_OVERRIDE_ACTIONS, CLUSTER_READ_LIMITS, CLUSTER_RUN_STATUSES, CLUSTER_RUN_STATUS_LABELS, CLUSTER_RUN_TRIGGERS, CLUSTER_SUMMARY_FIELDS, COVERAGE_NOTE_KINDS, DEFAULT_ACTIVITY_FILTER, EVIDENCE_LINK_PAGE_CAP, EXCLUSION_SOURCES, EXCLUSION_SOURCE_LABELS, LINK_KINDS, LINK_KIND_LABELS, LINK_ROLE_LABELS, LINK_TIERS, LOOKUP_CHUNK_ACCOUNTS, LOOKUP_CHUNK_CONCURRENCY, MANUAL_LINK_KIND, REJECTION_LABELS, REJECTION_REASONS, RELATED_ADDRESS_GRAPH_LIMITS, RELATIONSHIP_CLAIM_DESCRIPTIONS, RELATIONSHIP_CLAIM_LABELS, RUN_SUMMARY_FIELDS, STRENGTH_EXPLAINER, STRENGTH_LABEL, TERMINAL_CLUSTER_RUN_STATUSES, TRACKING_VIEW_LIMITS, activityDate, activityFilterActive, activityFilterError, activityFilterLabel, activityMatches, activityRangeLabel, activitySummary, activityTimeMatches, activityTimingIncomplete, addressClusterState, addressWatchMatches, addressesRead, bridgeReceiptEvidence, buildRelatedAddressView, caseAddressSeed, caseAddressSeeds, chainChoices, chainRef, clusterAnalysisProfileLabel, clusterRunAnswered, clusterRunReplacesAnswer, clusteringAttributionReason, coverageNotes, createRelatedAddressesApi, encodePathSegment, evidenceLabel, executionPerspective, expireRelatedAddressPreviews, extendTrackedView, failuresHidTheAnswer, filterByStrength, filterRelatedAddressView, formatStrength, fundingSources, heldOutReason, historyUnsupported, isAdmittedLink, isClusterAnalysisProfile, isClusterRunStatus, isCoverageNoteKind, isCurrentRelationshipClaim, isExclusionSource, isIdentityClaim, isLinkKind, isLiveActor, isManualMember, isMovementLink, isProvisionalRelationship, isRejectionReason, isTerminalClusterRunStatus, linkCounterpart, linkKindLabel, matchingForwarding, memberRowId, memberTie, mergeRoleCompositions, movementProofs, onlyChainFor, overrideNeedsPeer, provenanceOf, providerFailureText, providerTrouble, readAddressClusterEvidence, readNothing, rejectionReason, relationshipActivity, relationshipClaim, relationshipLifecycle, runInFlight, runProblemText, runVerdict, shortFingerprint, splitLinksByClaim, strengthViewMin, strengthViewOptions, toMemberRows, trackingBranches, trackingRun, uncoveredScope, viewCorrections, walkCutShort, weakestLinkOf };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map